mutation DeleteTranslations($ids: [ID!]!) {
  deleteTranslations(ids: $ids) {
    id
    deletedAt
  }
}
